import { hooks } from "@/store.js";
import { Button } from "@heroui/react";
import { Fragment, memo, useEffect, useMemo, useState } from "react";
import isEqual from "react-fast-compare";
import { useAdd } from "./comps/Add/index.jsx";
import Article from "./comps/Article.jsx";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useMemoizedFn, useRequest } from "ahooks";
import VerdantProvider from "@/components/VerdantProvider.jsx";
import { ModalProvider } from "react-modal-hook";
import { usePreventScroll } from "@react-aria/overlays";

// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/bar
import { ResponsiveBar } from "@nivo/bar";
import { CATEGORY } from "./const.js";
import { getDataService } from "../PlanDetail/service.js";
import { useLocation } from "react-router-dom";
import { CURRENCY_CONFIG } from "@/const.js";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const MyResponsiveBar = ({
	data,
}: {
	data: {
		type: string;
		value: string;
		花费: number;
	}[];
}) => (
	<ResponsiveBar
		data={data}
		keys={["花费"]}
		indexBy="type"
		margin={{ top: 50, right: 40, bottom: 50, left: 60 }}
		padding={0.3}
		layout="horizontal"
		// valueScale={{ type: 'linear' }}
		// indexScale={{ type: 'band', round: true }}
		// colors={{ scheme: 'nivo' }}
		// defs={[
		//   {
		//     id: 'dots',
		//     type: 'patternDots',
		//     background: 'inherit',
		//     color: '#38bcb2',
		//     size: 4,
		//     padding: 1,
		//     stagger: true,
		//   },
		//   {
		//     id: 'lines',
		//     type: 'patternLines',
		//     background: 'inherit',
		//     color: '#eed312',
		//     rotation: -45,
		//     lineWidth: 6,
		//     spacing: 10,
		//   },
		// ]}
		// fill={[
		//   {
		//     match: {
		//       id: 'fries',
		//     },
		//     id: 'dots',
		//   },
		//   {
		//     match: {
		//       id: 'sandwich',
		//     },
		//     id: 'lines',
		//   },
		// ]}
		// borderColor={{
		//   from: 'color',
		//   modifiers: [['darker', 1.6]],
		// }}
		axisTop={null}
		axisRight={null}
		// axisBottom={{
		//   tickSize: 5,
		//   tickPadding: 5,
		//   tickRotation: 0,
		//   legend: 'country',
		//   legendPosition: 'middle',
		//   legendOffset: 32,
		//   truncateTickAt: 0,
		// }}
		// axisLeft={{
		//   tickSize: 5,
		//   tickPadding: 5,
		//   tickRotation: 0,
		//   legend: 'food',
		//   legendPosition: 'middle',
		//   legendOffset: -40,
		//   truncateTickAt: 0,
		// }}
		// labelSkipWidth={12}
		// labelSkipHeight={12}
		// labelTextColor={{
		//   from: 'color',
		//   modifiers: [['darker', 1.6]],
		// }}
		// legends={[
		//   {
		//     dataFrom: 'keys',
		//     anchor: 'bottom-right',
		//     direction: 'column',
		//     justify: false,
		//     translateX: 120,
		//     translateY: 0,
		//     itemsSpacing: 2,
		//     itemWidth: 100,
		//     itemHeight: 20,
		//     itemDirection: 'left-to-right',
		//     itemOpacity: 0.85,
		//     symbolSize: 20,
		//     effects: [
		//       {
		//         on: 'hover',
		//         style: {
		//           itemOpacity: 1,
		//         },
		//       },
		//     ],
		//   },
		// ]}
		// role='application'
		// ariaLabel='Nivo bar chart demo'
		// barAriaLabel={(e) =>
		//   e.id + ': ' + e.formattedValue + ' in country: ' + e.indexValue
		// }
	/>
);

const ExpenseDetail = memo(
	({ onClose, planId }: { onClose: () => void; planId: string }) => {
		const items = hooks.useAllExpense({
			index: {
				where: "planId",

				equals: planId,
				order: "desc",
			},
		});
		const { show: addShow } = useAdd({ planId });
		const total = useMemo(() => {
			return items.reduce((prev, cur) => {
				return (
					prev + CURRENCY_CONFIG[cur.get("currency")]?.rate * cur.get("amount")
				);
			}, 0);
		}, [items]);

		const data = useMemo(() => {
			const result = CATEGORY.map((i) => ({
				type: i.label,
				value: i.value,
				花费: 0,
			}));

			for (const item of items) {
				const cateIdx = result.findIndex(
					(i) => i.value === item.get("category"),
				);

				if (cateIdx !== -1) {
					result[cateIdx].花费 +=
						CURRENCY_CONFIG[item.get("currency")]?.rate * item.get("amount");
				}
			}
			return result.filter((i) => i.花费);
		}, [items]);

		const { data: planData } = useRequest(
			async () => (planId ? await getDataService({ id: planId }) : undefined),
			{
				refreshDeps: [planId],
			},
		);

		const location = useLocation();
		const visible = useMemo(
			() => location.pathname.includes("expense"),
			[location.pathname],
		);

		usePreventScroll({
			isDisabled: !visible,
		});

		if (!visible) return null;

		return (
			<div
				className={`overflow-auto h-screen fixed top-0 left-0 w-full z-50 ${
					visible ? " opacity-100" : "opacity-0"
				}  bg-white animate__animated  animate__faster ${
					visible ? "animate__slideInRight" : "animate__slideOutRight"
				}`}
			>
				<header className="bg-blue-600 text-white sticky top-0 left-0 w-full pt-safe z-10 ">
					<div
						className="flex items-center  py-2 px-4"
						onClick={() => {
							onClose();
						}}
					>
						<i className="ic-round md-arrow_back" />
						<span className="ml-2">{planData?.title}</span>
					</div>
				</header>
				<div className="bg-blue-600 text-white  pb-16 pt-8 ">
					<span className="font-[500] text-xl text-white/80 block text-center">
						花费
					</span>
					<span className="font-[din] font-bold text-5xl flex items-center justify-center text-center mt-4">
						<span className="-ml-6 scale-90 block">￥</span>
						{total.toLocaleString(undefined, {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
					</span>
				</div>

				<div
					className="sticky bg-blue-600  z-10 -mt-6"
					style={{
						top: "calc(env(safe-area-inset-top) + 40px)",
					}}
				>
					<div className=" rounded-t-3xl bg-white h-6    " />
				</div>

				<div className="min-h-screen">
					{items
						.sort((a, b) => {
							return +new Date(b.get("date")) - +new Date(a.get("date"));
						})
						.map((item, index, array) => {
							const showTime =
								item.get("date") !== array[index - 1]?.get("date");

							return (
								<Fragment key={item.get("id")}>
									{showTime && (
										<span className="px-4 text-gray-500 text-xs">
											{item.get("date")}
										</span>
									)}
									<Article item={item} />
								</Fragment>
							);
						})}
				</div>

				<MyResponsiveBar data={data} />

				<div className="sticky bottom-0 pb-6 mb-safe flex items-center justify-center w-full z-10">
					<Button
						radius="full"
						className="bg-blue-600 text-white font-semibold "
						variant="shadow"
						size="lg"
						startContent={
							<i className="ic-round md-add w-9 h-9 text-2xl leading-9 -ml-4  rounded-full bg-white/15" />
						}
						onPress={() => addShow({})}
					>
						添加支出
					</Button>
					<Button
						radius="full"
						variant="ghost"
						onPress={() => {
							onClose();
						}}
						startContent={
							<i className="ic-round md-close_fullscreen text-gray-500 text-xl " />
						}
						className=" bg-white/80  backdrop-blur-md absolute  right-4 min-w-0 px-3 border-1"
						size="lg"
					/>
				</div>
			</div>
		);
	},
	isEqual,
);

export const ExpenseDetailPage = NiceModal.create(
	({ planId }: { planId: string }) => {
		const modal = useModal();
		const handleClose = useMemoizedFn(() => {
			modal.hide();
		});
		const [visible, setVisible] = useState(false);

		return (
			<VerdantProvider>
				<ModalProvider>
					<div
						className={`overflow-auto h-screen fixed top-0 left-0 w-full z-50 ${
							visible ? " opacity-100" : "opacity-0"
						}  bg-white animate__animated  animate__faster ${
							modal.visible ? "animate__slideInRight" : "animate__slideOutRight"
						}`}
						onAnimationEnd={() => {
							if (!modal.visible) {
								modal.remove();
							}
						}}
						onAnimationStart={() => {
							if (modal.visible) {
								setVisible(true);
							}
						}}
					>
						<ExpenseDetail onClose={handleClose} planId={planId} />
					</div>
				</ModalProvider>
			</VerdantProvider>
		);
	},
);

export default ExpenseDetail;
